/**
 * Extracts the color from a profile icon object (discriminated union).
 */
export const getProfileIconColor = (icon?: unknown): string | undefined => {
  if (icon && typeof icon === 'object' && 'color' in icon) {
    return (icon as { color: string }).color;
  }
  return undefined;
};

/**
 * Extracts the image URL from a profile icon object (discriminated union).
 */
export const getProfileIconImage = (icon?: unknown): string | undefined => {
  if (icon && typeof icon === 'object' && 'image' in icon) {
    return (icon as { image: string }).image;
  }
  return undefined;
};
